import React from 'react';
import PropTypes from 'prop-types';

// Utils
import cn from '../../../utils/tools/cn';

// Images
import { ReactComponent as EmptyUsers } from '../../../assets/images/empty_views/users.svg';
import { ReactComponent as EmptyMedias } from '../../../assets/images/empty_views/medias.svg';
import { ReactComponent as EmptyProducts } from '../../../assets/images/empty_views/product.svg';
import { ReactComponent as EmptyAccommodations } from '../../../assets/images/empty_views/accommodation.svg';
import { ReactComponent as EmptyEstablishments } from '../../../assets/images/empty_views/establishment.svg';

import styles from './EmptyList.module.scss';

const themes = {
  users: <EmptyUsers className={styles.image} />,
  medias: <EmptyMedias className={styles.image} />,
  products: <EmptyProducts className={styles.image} />,
  accommodations: <EmptyAccommodations className={styles.image} />,
  establishment: <EmptyEstablishments className={styles.image} />,
};

function EmptyList({
  imageTheme, title, text,
}) {
  return (
    <div className="d-flex center m-b-20">
      <div className={cn([styles.max, 'd-flex d-col center'])}>
        {imageTheme ? (
          <div>
            <div className="p-relative">
              {themes[imageTheme]}
            </div>
          </div>
        ) : null}

        <div className="d-flex d-col center p-relative">
          {title ? <h2 className="m-b-20 fs-24 fw-600 c-neutral-01">{title}</h2> : null}
          {text ? <p className="m-b-30 fs-16 fw-300">{text}</p> : null}
        </div>
      </div>
    </div>
  );
}

EmptyList.propTypes = {
  imageTheme: PropTypes.oneOf(['users', 'medias', 'products', 'accommodations', 'establishment']),
  title: PropTypes.string,
  text: PropTypes.string,
};

EmptyList.defaultProps = {
  imageTheme: null,
  title: null,
  text: null,
};

export default EmptyList;
